import React from 'react'
import PropTypes from 'prop-types'
import { getColor } from 'utils/uiHelpers'

const Attachment = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="19"
    viewBox="0 0 18 19"
  >
    <path
      fill={getColor(color)}
      fillRule="evenodd"
      d="M16.734 9.327l-6.96 6.84c-1.899 1.866-5.063 1.866-6.961 0-.915-.898-1.477-2.142-1.477-3.454 0-1.313.492-2.488 1.476-3.386L9.985 2.28c.563-.622 1.407-.898 2.25-.898.844 0 1.618.345 2.25.898 1.266 1.244 1.266 3.178 0 4.422l-6.68 6.563c-.562.553-1.476.553-1.968 0a1.353 1.353 0 0 1-.422-.967c0-.345.14-.69.422-.967l6.469-6.356a.66.66 0 0 0 0-.968.688.688 0 0 0-.985 0l-6.468 6.357c-.633.483-.915 1.174-.915 1.934s.282 1.451.844 1.935c1.055 1.036 2.883 1.036 4.008 0l6.68-6.564c1.758-1.727 1.758-4.629 0-6.356A4.68 4.68 0 0 0 12.234 0 4.68 4.68 0 0 0 9 1.313L1.828 8.36C.633 9.535 0 11.124 0 12.782s.633 3.247 1.828 4.422C3.094 18.447 4.711 19 6.328 19s3.234-.622 4.5-1.796l6.961-6.84a.66.66 0 0 0 0-.968c-.352-.345-.773-.345-1.055-.069z"
    />
  </svg>
)

Attachment.propTypes = {
  color: PropTypes.string,
}

Attachment.defaultProps = {
  color: 'slate-grey',
}

export default Attachment
